import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
import Nav from "./Pages/Nav";
import AboutUs from "./Pages/AboutUs";
import EMICalculator from "./Pages/EMICalculator";
import Blogs from "./Pages/Blogs";
import Faqs from "./Pages/Faqs";
import ContactUs from "./Pages/ContactUs";
import ApplyForLoan from "./Pages/ApplyForLoan";
import HomeLoan from "./Pages/HomeLoan";
import PersonalLoan from "./Pages/PersonalLoan";
import BusinessLoan from "./Pages/BusinessLoan";
import PropertyLoan from "./Pages/PropertyLoan";
import EducationLoan from "./Pages/EducationLoan";
import CarLoan from "./Pages/CarLoan";
import BikeLoan from "./Pages/BikeLoan";
import MarriageLoan from "./Pages/MarriageLoan";
import GoldLoan from "./Pages/GoldLoan";
import LoanonCreditCard from "./Pages/LoanonCreditCard";
import Footer from "./Pages/Footer";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsOfService from "./Pages/TermsOfService";
import Disclaimer from "./Pages/Disclaimer";
import ScrollToTop from "./Pages/ScrollToTop";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Nav />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/emi-calculator" element={<EMICalculator />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/apply-for-loan" element={<ApplyForLoan />} />
        <Route path="/home-loan" element={<HomeLoan />} />
        <Route path="/personal-loan" element={<PersonalLoan />} />
        <Route path="/business-loan" element={<BusinessLoan />} />
        <Route path="/property-loan" element={<PropertyLoan />} />
        <Route path="/education-loan" element={<EducationLoan />} />
        <Route path="/car-loan" element={<CarLoan />} />
        <Route path="/bike-loan" element={<BikeLoan />} />
        <Route path="/marriage-loan" element={<MarriageLoan />} />
        <Route path="/gold-loan" element={<GoldLoan />} />
        <Route path="/credit-card-loan" element={<LoanonCreditCard />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
